import styled, { css } from "styled-components";

export const FlagImage = styled.figure`
  display: flex;
  justify-content: center;
  width: 40px;
  height: 40px;
  margin-bottom: 20px;
  z-index: 1;
  position: relative;
`;

export const ProductItem = styled.div`
  position: relative;

  ${props =>
    props.withPrice &&
    css`
      height: 450px;
    `}

  a {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-decoration: none;
    color: inherit;
    padding: 20px;
    border-radius: 6px;
    transition: 0.5s;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    ${props =>
      props.withPrice &&
      css`
        position: absolute;
      `}
  }

  &:hover {
    box-shadow: 1px 1px 19px rgba(0, 0, 0, 0.11);

    h3 {
      color: #333;
    }
  }
`;

export const ProductTag = styled.div`
  width: 150px;
  height: 150px;
  overflow: hidden;
  position: absolute;
  top: -10px;
  right: -10px;
  &:before {
    position: absolute;
    z-index: -1;
    content: '';
    display: block;
    border: 5px solid #2980b9;
    border-top-color: transparent;
    top: 0;
    left: 0;
    border-right-color: transparent;
  }
  &:after {
    position: absolute;
    z-index: -1;
    content: '';
    display: block;
    border: 5px solid #2980b9;
    border-top-color: transparent;
    border-right-color: transparent;
    top: 0;
    left: 0;
  }
  span {
    position: absolute;
    display: block;
    width: 225px;
    z-index: 2;
    padding: 15px 0;
    background-color: #000;
    box-shadow: 0 5px 10px rgba(0,0,0,.1);
    color: #fff;
    font: 700 18px/1 'Lato', sans-serif;
    text-shadow: 0 1px 1px rgba(0,0,0,.2);
    text-transform: uppercase;
    text-align: center;
    left: -25px;
    top: 30px;
    transform: rotate(45deg);
  }
`;

export const ProductName = styled.h3`
  margin-bottom: 6px;
  color: #666;
  font-size: 14px;
  font-weight: normal;
  line-height: 16px;
  text-transform: uppercase;
`;

export const ProductImage = styled.figure`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-bottom: 20px;
  border-radius: 8px;
  border: 1px solid #dee2e6;
  padding: 2px;

  ${props =>
    props.clean &&
    css`
      border-radius: 0;
      border: none;
    `};

  img {
    max-height: 224px;
  }
`;

export const ProductSku = styled.span`
  font-size: 12px;
  margin-bottom: 6px;
`;

export const ProductPrice = styled.span`
  color: #222;
  font-weight: bold;
`;
export const SoldOut = styled.span`
  color: #222;
  font-weight: bold;
  font-size: 24px;
`;

export const ProductTax = styled.span`
  margin-left: 5px;
`;

export const QuantityChanger = styled.div`
  display: flex;
  margin-top: 20px;
  position: absolute;
  top: auto;
  left: 20px;
  right: 20px;
  bottom: 20px;
  justify-content: center;
`;

export const AddButton = styled.button`
  font-family: "Poppins", sans-serif;
  font-size: 14px;
  background-color: #e69e00;
  border-radius: 6px;
  padding: 10px 16px;
  color: #fff;
  font-weight: bold;
  text-decoration: none;
  transition: 0.2s;
  text-align: center;
  cursor: pointer;
  border: none;

  &:hover {
    transform: scale(1.05);
    background-color: #f1a602;
  }
`;

export const AddButtonSouv = styled.button`
  font-family: "Poppins", sans-serif;
  font-size: 14px;
  background-color: black;
  margin-left: 5px;
  border-radius: 6px;
  padding: 10px 16px;
  color: #fff;
  font-weight: bold;
  text-decoration: none;
  transition: 0.2s;
  text-align: center;
  cursor: pointer;
  border: none;

  &:hover {
    transform: scale(1.05);
  }
`;
